



























































import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props, ReportHeader } from "./types";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import SelectWeekly from "@/components/Pages/Report/Molecules/SelectWeekly/index.vue";
import Card from "./Atoms/Card/index.vue";
import Layout from "./Atoms/Layout/index.vue";
import Tabs from "./Atoms/Tabs/index.vue";
import ReportProjectHeader from "./Molecules/ReportProjectHeader/index.vue";
import ReportNumberField from "./Molecules/ReportNumberField/index.vue";
import LikedChart from "./Molecules/LikedChart/index.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "Report",
  components: {
    Body,
    Heading,
    Card,
    ReportProjectHeader,
    ReportNumberField,
    Layout,
    Tabs,
    LikedChart,
    SelectWeekly
  },
  props: {
    report: {
      type: Object as PropType<Props["report"]>,
      default: undefined
    },
    reports: {
      type: Array as PropType<Props["reports"]>,
      required: true
    }
  },
  data() {
    return {
      reportHeading: {
        title: "採用計画名が入ります",
        terms: "期間が入ります",
        imgSrc:
          "https://staging-data-onecareer.s3.amazonaws.com/uploads/company/square_logo/682/1589916689-skyperfectjsat_200x200.jpg",
        imgAlt: "スカパー"
      },
      selectedTabKey: "liked",
      tabs: [{ key: "liked", label: "お気に入り" }],
      chartType: "WEEKLY",
      dataArray: [
        {
          year: 2020,
          month: 6,
          week: 2,
          url: "/api/recruitment_planning/v1/plans/1/weekly_reports/4"
        },
        {
          year: 2020,
          month: 6,
          week: 1,
          url: "/api/recruitment_planning/v1/plans/1/weekly_reports/3"
        },
        {
          year: 2020,
          month: 5,
          week: 10,
          url: "/api/recruitment_planning/v1/plans/1/monthly_reports/1"
        },
        {
          year: 2020,
          month: 5,
          week: 5,
          url: "/api/recruitment_planning/v1/plans/1/weekly_reports/1"
        },
        {
          year: 2020,
          month: 5,
          week: 4,
          url: "/api/recruitment_planning/v1/plans/1/weekly_reports/1"
        },
        {
          year: 2020,
          month: 5,
          week: 3,
          url: "/api/recruitment_planning/v1/plans/1/weekly_reports/1"
        },
        {
          year: 2020,
          month: 5,
          week: 2,
          url: "/api/recruitment_planning/v1/plans/1/weekly_reports/1"
        },
        {
          year: 2020,
          month: 5,
          week: 1,
          url: "/api/recruitment_planning/v1/plans/1/weekly_reports/1"
        }
      ].map((item: any) => new ReportHeader(item))
    };
  },
  methods: {
    handleClickWeeklySelect(value) {
      this.$emit("selectWeekly", value);
    }
  }
});
